import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/inventory',
  alias: ['/sistema/inventory/Index'],
  documento: 'inventory',
  acceso: 'sesion',
  filas: ['038'],
  cita: 'Areas/Inventory/Controllers/InventoryController.cs:40',
} satisfies RutaProd;
